module.exports = "<div class=\"progress-bar\">\n    <div\n        class=\"progress\"\n        [ngStyle]=\"{'width.%': progress}\"\n    ></div>\n</div>\n"